import { FunctionComponent } from "react";

import ListPreview from "@/assets/images/onboarding/list-preview.png";
import GradientOverlay from "@/assets/images/onboarding/gradient-light-transparent.png";

/**
 * Decorative backdrop for the signup card: the same blurred Lead Lists product
 * screenshot + soft gradient overlay the in-app onboarding uses
 * (see OnboardingLayout), so signup and onboarding share one continuous
 * background. Purely visual — hidden from assistive tech.
 *
 * NOTE: the register route is wrapped in AuthLayout, which paints its own
 * gradient at z-index:-1. These layers sit at z-0 (above that layout gradient,
 * below the z-10 card) so the screenshot is actually visible.
 */
export const RegisterBackground: FunctionComponent = () => (
	<>
		<img
			alt=""
			aria-hidden
			className="fixed inset-0 z-0 h-full w-full object-cover"
			src={ListPreview}
		/>
		<img
			alt=""
			aria-hidden
			className="fixed inset-0 z-0 h-full w-full object-cover opacity-50"
			src={GradientOverlay}
		/>
	</>
);
